export const VUEX_LOCALIZATION_CHANGE_LANG = 'VUEX_LOCALIZATION_CHANGE_LANG'
